import type { ProxyEndpointConfig } from "@/composables/types/searchClient";

const NO_DRAFT_WITHDRAWN_ORDER_FILTERS =
  "order.core.status:'Submitted' OR order.core.status:'Paid, Confirmed' OR order.core.status:'Fulfilled'";
const NO_CUSTOM_SESSION_FILTERS = "order.session.channel:'Core' OR order.session.channel:'Exchange'";
const ACCEPTANCE_STATUSES =
  "order.core.host_accepted_status:'Ready for Review' OR " +
  "order.core.host_accepted_status:'Accepted' OR " +
  "order.core.host_accepted_status:'Provisionally Accepted' OR " +
  "order.core.host_accepted_status:'Not Accepted' OR " +
  "order.core.host_accepted_status:'Conditionally Accepted'";
const ACCEPTANCE_CRITERIA = "order.session.requires_application:true";
const approvalsPageFilters = `${NO_DRAFT_WITHDRAWN_ORDER_FILTERS} AND ${NO_CUSTOM_SESSION_FILTERS}`;
const acceptancePageFilters = `${NO_DRAFT_WITHDRAWN_ORDER_FILTERS} AND ${ACCEPTANCE_STATUSES} AND ${ACCEPTANCE_CRITERIA}`;

interface AlgoliaPagePreFilters {
  approvals: string;
  acceptance: string;
}

export const ALGOLIA_PAGE_PRE_FILTER: AlgoliaPagePreFilters = {
  approvals: approvalsPageFilters,
  acceptance: acceptancePageFilters,
};

const MY_STUDENTS_ALGOLIA_PROXY: string = `${import.meta.env.VITE_PROFILE_SERVICE_ENDPOINT}/v1/search`;
const MY_STUDENTS_LARAVEL_PREFIX: string = "/search";
const MY_STUDENTS_QUERY_ENDPOINT: string = "/students";
const MY_STUDENTS_FACET_ENDPOINT: string = "/students-facets";
const MY_STUDENTS_EXPORT_ENDPOINT: string = "/students-export";
const MY_STUDENTS_TOTALS_ENDPOINT: string = "/students-totals";

export const PROXY_ENDPOINT_CONFIG: ProxyEndpointConfig = {
  base: MY_STUDENTS_ALGOLIA_PROXY,
  laravelPath: MY_STUDENTS_LARAVEL_PREFIX,
  query: MY_STUDENTS_QUERY_ENDPOINT,
  facet: MY_STUDENTS_FACET_ENDPOINT,
  export: MY_STUDENTS_EXPORT_ENDPOINT,
  totals: MY_STUDENTS_TOTALS_ENDPOINT,
};
